<template>
  <div>
    <b-container fluid style="min-height: calc(100vh - 181px);" class="px-0">
      <b-card id="card-principal" class="mb-0 pb-0">
        <template #header>
          <i class="fas fa-edit"></i>
          <strong>{{$lang.PCI.Items.Title}}</strong>
        </template>
        <div class="d-flex">

          <!-- Item Treeview screen -->
          <div id="col-treeview" class="pr-0">
            <b-card>
              <b-overlay :show="isEditing || isAdding" :opacity="0.75" blur="5px" variant="transparent" >
                <template #overlay>
                  <div class="text-center">
                    <i class="far fa-edit fa-3x"></i>
                  </div>
                </template>
                <item-tree-view ref="treeview"
                                :list="objList"
                                :serializer="it => `(${it.code}) - ${it.name}${it.mirrorCode ? ' - (' + it.mirrorCode + ')': ''}`"
                                :showAddButton="it => it.type === 1"
                                :showDeleteButton="hasRole(roles.RW_OPER_PCI_ITEM_DEL)"
                                :showReloadButton="true"
                                :showSortButton="true"
                                v-on:selectitem="onSelectItem"
                                v-on:add="onAdd"
                                v-on:delete="onDelete"
                                v-on:reload="onLoad"
                                v-on:saveSort="onSaveSort">
                </item-tree-view>
              </b-overlay>
            </b-card>
          </div>

          <!-- Item Maintenance screen -->
          <div class="col">
            <AddItems ref="addItems"
                      v-on:back="onBack"
                      v-on:update="onUpdate"
                      v-on:create="onCreate"
                      v-if="isEditing || isAdding" />
          </div>
        </div>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import Items from './items'
export default Items
</script>

<style scoped>
#col-treeview {
  height: calc(100vh - 270px);
  width: 550px;
}

.card {
  height: 100%;
}

.b-overlay-wrap {
  height: 100%;
}

.w-20 {
  width: 20%;
}

.w-70 {
  width: 70%;
}

.w-10 {
  width: 10%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/items/items.vue